import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Reels} from '@nolimitcity/slot-game/bin/core/reel/reelarea/Reels';
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Elastic, Linear, TimelineLite, TweenLite} from "gsap";
import {BarbarianFuryGameConfig} from "../../BarbarianFuryGameConfig";
import {BFGameEvent} from "../../events/BFGameEvent";
import {BarbarianFuryGameMode} from "../../gamemode/BarbarianFuryGameMode";
import {MultiplierIndicator} from "../../multiplier/MultiplierIndicator";
import {BarbarianFuryParsedGameData} from "../../server/data/BarbarianFuryParsedGameData";

/**
 * Created by Ning Jiang on 4/3/2018.
 */

export class BFWildSymbolWPView extends BaseView {

    //todo
    private readonly _style:any = {
        font : "23px NumbersWinCountUp",
        tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    private _layer:ScalableLayer;
    private _multiplierCounter:PIXI.BitmapText;
    private _timeline:TimelineLite;
    private _multiplierArray:any[];// = [this._multiplierCounter, this._multiplierCounter, this._multiplierCounter];
    private _multiplierItem:number;
    private _isStickyWild:boolean = false;
    private _symMultiperAnims:TimelineSprite[] = [];
    private _resotreReelID:number[] = [];
    private _resotretext:string[] = [];
    private _isResourceLoaded:boolean = false;
    private _initResponseReceived:boolean = false;
    private _nudgedStepsCount:number = 0;
    private _nudgeData:BarbarianFuryParsedGameData | null;


    constructor() {
        super();
        this._timeline = new TimelineLite();
        this._layer = StageManager.getLayer(BarbarianFuryGameConfig.instance.LAYERS.SYMBOLS.name); // change layer from pop_numbers to symbols to keep multiplier behind jail bars.
        this._multiplierArray = [this._multiplierCounter, this._multiplierCounter, this._multiplierCounter];
    }

    public showMultiplierOnRestore(text:string, reelId:number, isAborted:boolean, onRestore:boolean = false):void {
        if(!this._isResourceLoaded) {
            this._initResponseReceived = true;
            this._resotreReelID.push(reelId);
            this._resotretext.push(text);
            return;
        } else {
            this.showMultiplier(text, reelId, isAborted);
        }
    }

    public showMultiplier(text:string, reelId:number, isAborted:boolean):void {
        if(reelId === undefined) {
            return;
        }
        let totalNudgingSteps = this.getNudgingSteps(this._nudgeData),
            currCount = parseInt(text.replace("x", ""));

        if(this._nudgeData!.mode.indexOf(BarbarianFuryGameMode.FREESPIN) > -1 && this._nudgedStepsCount === 0) {
            this._nudgedStepsCount = 1
        }

        if(currCount === 1 || currCount === 2) {
            this._nudgedStepsCount = this._nudgedStepsCount + currCount;
        } else {
            this._nudgedStepsCount++;
        }

        if(this._nudgeData!.isRestoreState) {
            EventHandler.dispatchEvent(new GameEvent(MultiplierIndicator.UPDATE_MULTIPLIER, this._nudgeData!.freeSpinMultiplier));
        } else {
            EventHandler.dispatchEvent(new GameEvent(MultiplierIndicator.UPDATE_MULTIPLIER, this._nudgedStepsCount));
        }

        this.kill();
        this._multiplierItem = reelId - 1;

        let duration:number = isAborted ? 0 : 0.3;

        if(isAborted) {
            this._timeline.pause();
            this._timeline.kill();
        }

        this._multiplierArray[this._multiplierItem].text = text;
        this._multiplierArray[this._multiplierItem].updateTransform();
        this.unDimWildMultiplier();
        // fix for #133
        this._multiplierArray[this._multiplierItem].position.set(Helper.getSymbolPositions(reelId, 0)[0] - 15, (GameConfig.instance.GAME_HEIGHT * 0.5) + 33);
        this._multiplierArray[this._multiplierItem].pivot.set(this._multiplierArray[this._multiplierItem].textWidth * 0.5, this._multiplierArray[this._multiplierItem].textHeight * 0.5);
        this._multiplierArray[this._multiplierItem].alpha = 1;
        this._multiplierArray[this._multiplierItem].visible = true;

        this._timeline.add(
            TweenLite.fromTo(this._multiplierArray[this._multiplierItem].scale, duration,
                {x : 0.7, y : 0.7},
                {
                    x : 1,
                    y : 1,
                    ease : Elastic.easeOut.config(2, 1),
                    onStart : () => {
                        if(this._multiplierArray[this._multiplierItem].visible && !isAborted) {
                            this._symMultiperAnims[this._multiplierItem].setFrame(0);
                            this._symMultiperAnims[this._multiplierItem].getAnimationAutoShowHide(true, true);
                        }
                    }
                }
            )
        );
        //enable below code to auto hide multipliers
        /*this._timeline.add(TweenLite.to(this._multiplierArray[this._multiplierItem], 0.3, {
            alpha: 1, onComplete: () => {
                this._multiplierCounter.visible = true;
            }
        }));*/

        this._timeline.play();
    }

    /**
     * function to dim down wild multiplier when scatter nudge starts
     * To fix #260
     */
    public dimDownWildMultiplierOnScatterNudgeStart():void {
        for(let i = 0; i < this._multiplierArray.length; i++) {
            if(this._multiplierArray[i].visible) {
                this._multiplierArray[i].tint = 0x555555;
                // in case of scatter trigger and wild win  hiding fire and chaging state of w symbol
                EventHandler.dispatchEvent(new GameEvent(BFGameEvent.HIDE_WILD_FIRE));
                let sym = Reels.getSymbol(i + 1, 1);
                sym!.changeState({
                    state : BarbarianFuryGameConfig.instance.SYMBOL_STATES.noWin,
                    fadeInDuration : 0
                });
            }
        }
    }

    /**
     * function to undim multiplier when showMulltiplier called.
     */
    private unDimWildMultiplier():void {
        for(let i = 0; i < this._multiplierArray.length; i++) {
            this._multiplierArray[i].tint = 16777215;
        }
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, () => this.onSpinStarted());
        EventHandler.addEventListener(this, BFGameEvent.SHOW_X1_MULTIPLIER, (event:GameEvent) => this.showX1Multiplier(event.params[0], event.params[1]));
        EventHandler.addEventListener(this, "setStickyWild", (event:GameEvent) => this.doStickyWild(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onServerDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onServerDataParsed(event.params[0]));
    }

    private onServerDataParsed(data:BarbarianFuryParsedGameData):void {
        this._nudgeData = data;
    }

    private doStickyWild(flag:boolean):void {
        this._isStickyWild = flag;
    }

    private showX1Multiplier(reelId:number, isAborted:boolean) {
        this.showMultiplier(`x1`, reelId, isAborted);
        const timeline:TimelineLite = new TimelineLite({
            paused : true,
            onComplete : () => {
                timeline.kill();
            }
        });
        if((this._nudgeData!.betWins.length > 0 && this._nudgeData!.mode === BarbarianFuryGameMode.NORMAL) || this._nudgeData!.mode === BarbarianFuryGameMode.FREESPIN) {
            timeline.add(() => {
                EventHandler.dispatchEvent(new GameEvent(BFGameEvent.STOP_WILD_FIRE_ANIM, true, reelId));
                EventHandler.dispatchEvent(new GameEvent("PLAY_WILD_ROAR_SOUND"));
            }, 0.5);
        }
        timeline.play(0);
    }

    protected onSpinStarted():void {
        let currMultiplier:number = 0;
        if(this._nudgeData!.isRestoreState) {
            currMultiplier = this._nudgeData!.freeSpinMultiplier;
        } else {
            currMultiplier = this._nudgeData!.currentMultiplier;
        }

        if(this._nudgeData!.mode === BarbarianFuryGameMode.NORMAL) {
            if(this._nudgeData!.nextMode === BarbarianFuryGameMode.STACKED_RESPIN) {
                this._nudgedStepsCount = currMultiplier;
            } else {
                this._nudgedStepsCount = 0;
            }
        } else if(this._nudgeData!.mode.indexOf("SPIN") > -1 && this._nudgeData!.nextMode === BarbarianFuryGameMode.NORMAL) {
            this._nudgedStepsCount = 0;
        } else {
            this._nudgedStepsCount = currMultiplier;
        }

        if(this._isStickyWild) {
            this._isStickyWild = false;
            return;
        }
        //this.hideMultiplier();
        for(let i:number = 0; i < this._multiplierArray.length; i++) {
            if(this._multiplierArray[i].visible) {
                let currPosX = this._multiplierArray[i].position.x,
                    currPosY = this._multiplierArray[i].position.y,
                    newPosY = currPosY - 50,
                    lastPosY = newPosY + 400;

                const timeline:TimelineLite = new TimelineLite({
                    paused : true,
                    onComplete : () => {
                        timeline.kill();
                    }
                });

                timeline.add(() => {
                        TweenLite.fromTo(this._multiplierArray[i].position, 0.1, {y : currPosY}, {
                            y : newPosY,
                            ease : Linear.easeInOut,
                            onComplete : () => {
                                TweenLite.fromTo(this._multiplierArray[i].position, 0.25, {y : newPosY}, {
                                    y : lastPosY,
                                    delay : 0.08,
                                    ease : Linear.easeInOut,
                                    onComplete : () => {
                                        this._multiplierArray[i].alpha = 0;
                                        this._multiplierArray[i].visible = false;

                                        this._symMultiperAnims[i].visible = false;
                                        this._symMultiperAnims[i].setFrame(0);
                                    }
                                })
                            }
                        })
                    }, 0
                );
                timeline.play(0);
            }
        }
    }

    protected hideMultiplier():void {
        for(let i:number = 0; i < this._multiplierArray.length; i++) {
            if(this._multiplierArray[i].visible) {
                this._multiplierArray[i].alpha = 0;
                this._multiplierArray[i].visible = false;

                this._symMultiperAnims[i].visible = false;
                this._symMultiperAnims[i].setFrame(0);
            }
        }
    }

    protected initAnimations():void {
        this._isResourceLoaded = true;
        this.createMultiplierBitmap();
        this.hideMultiplier();
        if(this._initResponseReceived) {
            for(let i = 0; i < this._resotreReelID.length; i++) {
                this.showMultiplier(this._resotretext[i], this._resotreReelID[i], true);
            }
        }
    }

    private getNudgingSteps(data:BarbarianFuryParsedGameData | null):number[] {
        let nudgeData = data,
            totalStepsToNudge:number[] = [],
            nudgingReels:boolean[] = [];

        if(data!.isRestoreState) {
            nudgingReels = data!.overlayWildInRespin;
        } else {
            nudgingReels = data!.doReelNudge;
        }

        for(let i:number = 0; i < nudgingReels.length; i++) {
            if(!(nudgingReels[i])) {
                totalStepsToNudge[i] = 0;
            } else {
                let maxStepsPerReel = 5;
                for(let j:number = 1; j < nudgeData!.reels[i].length - 1; j++) {
                    if(nudgeData!.reels[i][j].indexOf("W") > -1) {
                        maxStepsPerReel--;
                    }
                }
                totalStepsToNudge[i] = maxStepsPerReel;
            }
        }

        return totalStepsToNudge;
    }

    private createMultiplierBitmap():void {
        for(let i:number = 0; i < this._multiplierArray.length; i++) {
            let container = new PIXI.Container();
            this._multiplierArray[i] = new PIXI.BitmapText("0", this._style);

            this._symMultiperAnims[i] = new TimelineSprite(GameResources.getTextures("symMultiplier"), 20);
            this._symMultiperAnims[i].anchor.set(0.5);
            this._symMultiperAnims[i].visible = false;
            this._symMultiperAnims[i].blendMode = PIXI.BLEND_MODES.ADD;
            this._symMultiperAnims[i].position.set(Helper.getSymbolPositions(i + 1, 0)[0] + 7, (GameConfig.instance.GAME_HEIGHT * 0.5) + 55)

            container.addChild(this._symMultiperAnims[i]);
            container.addChild(this._multiplierArray[i]);

            this._layer.addChild(container);
        }
    }

    private kill():void {
        if(this._timeline && this._timeline.isActive()) {
            this._timeline.paused();
            this._timeline.kill();
        }
    }
}